import { render, staticRenderFns } from "./MembersPlayerCard.vue?vue&type=template&id=4d3983b1&scoped=true"
import script from "./MembersPlayerCard.vue?vue&type=script&lang=js"
export * from "./MembersPlayerCard.vue?vue&type=script&lang=js"
import style0 from "./MembersPlayerCard.vue?vue&type=style&index=0&id=4d3983b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3983b1",
  null
  
)

export default component.exports